<template>
  <div class="gewerbestep3">

    <div class="semanticsection-title2 first primary--text">Firma/Unternehmen</div>

    <dmb-accordion ref="accordionStep3Firma"
                   :items="firmen"
                   component-name="FirmaBasis"
                   state-path="gewerbe.ui.accordions.step3Firma" />

    <template v-if="isKompex && !excludeGF">
      <div class="semanticsection-title2 primary--text">Inhaber/Geschäftsführer</div>

      <dmb-accordion ref="accordionStep3Gfs"
                     :items="geschaeftsfuehrer"
                     :child-props="{ withMvp: true, unused: ['beruf'] }"
                     component-name="GewerbePerson"
                     state-path="gewerbe.ui.accordions.step3Gfs" />
    </template>

    <div class="semanticsection-title2 primary--text">Beitragszahlung</div>

    <beitrags-zahlung></beitrags-zahlung>

    <v-row no-gutters class="stepperbuttons">
      <v-btn color="primary"
             class="standard-button"
             @click="$emit('step-back')">Zurück</v-btn>
      <v-spacer/>
      <v-btn color="primary"
             class="standard-button"
             @click="stepForward">Weiter</v-btn>
    </v-row>

  </div>
</template>

<script>
import twowayBindingMixin from '../../store/twowayBindingMixin';
import ValidationMixin from '../helper/ValidationMixin';
import DmbAccordion from './DmbAccordion';
import { mapGetters, mapState } from 'vuex';
import BeitragsZahlung from './BeitragsZahlung';

export default {
  name: "GewerbeStep3",
  components: { BeitragsZahlung, DmbAccordion },
  mixins: [ twowayBindingMixin, ValidationMixin ],
computed: {
    ...mapGetters([
      'versicherungsnehmer',
      'mvUnternehmen',
      'filialen',
      'personPath'
    ]),
    ...mapState({
      hasMvUnternehmen: state => state.gewerbe.ui.hasMvUnternehmen,
      hasFilialen: state => state.gewerbe.ui.hasFilialen,
      isKompex: state => state.gewerbe.ui.isKompex,
      excludeGF: state => state.gewerbe.ui.excludeGF
    }),
    firmen() {
      const vn = this.versicherungsnehmer;
      let allFirmen = [{
        key: vn.key,
        label: `Versichertes Unternehmen`,
        name: vn.name + " " + vn.rechtsform,
        statePath: this.personPath(vn.key),
        childProps: {
          unused: ['name'],
          disabled: ['rechtsform', 'branche']
        }
      }];

      if (this.hasMvUnternehmen) {
        const mvus = this.mvUnternehmen.map((mvu, i) => {
          return {
            key: mvu.key,
            label: `${ i + 1 }. weiteres Unternehmen `,
            name: mvu.name + " " + mvu.rechtsform,
            statePath: this.personPath(mvu.key),
            childProps: {
              unused: ['name', 'kontakt'],
              disabled: ['rechtsform', 'branche']
            }
          };
        });
        allFirmen = allFirmen.concat(mvus);
      }

      if (this.hasFilialen) {
        const filialen = this.filialen.map((fil, i) => {
          return {
            key: fil.key,
            label: `Filiale ${ i + 1 }`,
            statePath: this.personPath(fil.key),
            childProps: {
              unused: ['name', 'rechtsform', 'branche', 'kontakt', 'hr']
            }
          };
        });
        allFirmen = allFirmen.concat(filialen);
      }

      return allFirmen;
    },
    geschaeftsfuehrer() {
      return this.$store.getters.geschaeftsfuehrer.map((gf, i) => {
        return {
          key: gf.key,
          label: `${i + 1}. Inhaber/Geschäftsführer`,
          name: gf.firstname || gf.lastname
              ? (gf.firstname || '') + ' ' + (gf.lastname || '')
              : null,
          statePath: this.$store.getters.personPath(gf.key)
        };
      });
    }
  },
  methods: {
    stepForward() {
        this.$store.commit('telefonCleanup');
        this.$emit('step-forward');
    }
  }
};
</script>
